// @flow

import React from 'react';
import type { Node } from 'react';
import { Heading, Link } from '@riseart/common';
import { Section, SectionContent, Wrapper } from '@riseart/layout';
import { GridSquare, GridSquareItem } from '@riseart/grid';
import { PicturePlaceholder } from 'shared_components/common/artdirection/picture/Picture';

// Import styles
import {
  editorialCls,
  editorialItemCls,
  editorialDetailsCls,
  editorialDetailsTitleCls,
} from './Editorial.less';

type Props = {
  title: string,
  items: Array<{
    category: string,
    external: boolean,
    image: Object,
    title: string,
    subTitle: string,
    url: string,
  }>,
};

/**
 * CmsModuleEditorial
 *
 * @param {Props} props
 * @returns {Node}
 */
export const CmsModuleEditorial = ({ title, items }: Props): Node => (
  <Section background="gray">
    <Wrapper>
      <SectionContent
        title={title}
        headingProps={{ tag: 'h2', level: 3, align: 'center', uppercase: true }}
      >
        <GridSquare columnCount="2" className={editorialCls}>
          {items &&
            items.map((item) => (
              <GridSquareItem key={item.url} columnCount="2">
                <section className={editorialItemCls}>
                  <Link external href={item.url} title={item.title} type="light">
                    <PicturePlaceholder
                      type="grid.cmsEditorialTwoCol"
                      artDirectionKey="cms.editorial"
                      image={item.image}
                      alt={item.title}
                      lazyload
                    />
                  </Link>
                  <div className={editorialDetailsCls}>
                    {item.subTitle ? (
                      <Heading tag="h4" level="6" uppercase>
                        <Link external href={item.url} title={item.title}>
                          {item.subTitle}
                        </Link>
                      </Heading>
                    ) : null}
                    {item.title ? (
                      <Heading tag="h3" level="5" className={editorialDetailsTitleCls}>
                        <Link external href={item.url} title={item.title}>
                          {item.title}
                        </Link>
                      </Heading>
                    ) : null}
                  </div>
                </section>
              </GridSquareItem>
            ))}
        </GridSquare>
      </SectionContent>
    </Wrapper>
  </Section>
);
